import React, { useContext, useReducer } from "react";
import { Actions } from "../../reducers/Context";
import NavButton from "../../components/NavButton/index";
import MsmContext from "../../reducers/Context";

const LoggedIn = props => {
  const { dispatch, state } = useContext(MsmContext);

  //console.log("state", state);

  const clickedClubSettings = () => {
    window.location.href = `/${state.user.TeamSiteURL}/admin/settings/edit/club/details`;
  };

  const clickedCancel = () =>
  {
      window.tsUtilityModals.signupCancelCallback();
      dispatch({
        type: Actions.CANCELLED_SIGNUP
      });
  };

  return (
    state.user && (
      <>
        <div className="afs-msm-stage-content add-all-padding fx-container-y fx-align-centre">
          <div>
            <p>You are currently logged in as {state.user.UserFullName}</p>
            <p>
              By continuing you will be adding a new team to TeamStats that is
              separate from your existing team(s) and club(s).
            </p>
            <p>You will be able to access all teams using this user account.</p>
            <p>
              If you want to add another team to an existing club then club
              admin users can do so via club settings.
            </p>
          </div>
          <NavButton
            colour="teal"
            className="afs-msm-inline-button btn add-vert-margin"
            text="CLUB SETTINGS"
            onClick={clickedClubSettings}
          />
        </div>
        <div className="afs-msm-stage-action-buttons">
          <NavButton text="CANCEL" onClick={clickedCancel} />
          <NavButton
            text="CONTINUE"
            actionType={Actions.TO_STAGE}
            payload={{ toStage: "team-location" }}
          />
        </div>
      </>
    )
  );
};

export default {
  id: "logged-in",
  title: "Sign up to TeamStats",
  subtitles: [""],
  imageUrl:
    "https://assets.teamstats.net/img-m-600-70/backgrounds/football-background-1.jpg",
  component: LoggedIn,
  buttons: []
};
